<template>
  <section class="belt-products">

    <div class="section-heading">
      <h1>Our Belts</h1>
      <p>Find the perfect leather belt for every occasion and attire.</p>
    </div>

    <div class="belts-container">

      <!-- Belt 1 -->
      <div class="belt-card">
        <img :src="sterling" alt="Sterling Belt">

        <div class="belt-info">
          <h3>Sterling Belt</h3>
          <p>&#8358;6,500</p>

          <button @click="viewProduct(9)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 2 -->
      <div class="belt-card">
        <img :src="heritage" alt="Heritage Belt">

        <div class="belt-info">
          <h3>Heritage Belt</h3>
          <p>&#8358;5,500</p>

          <button @click="viewProduct(10)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 3 -->
      <div class="belt-card">
        <img :src="aura" alt="Aura Belt">

        <div class="belt-info">
          <h3>Aura Belt</h3>
          <p>&#8358;7,500</p>

          <button @click="viewProduct(11)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 4 -->
      <div class="belt-card">
        <img :src="rugged" alt="Rugged Belt">

        <div class="belt-info">
          <h3>Rugged Belt</h3>
          <p>&#8358;10,000</p>

          <button @click="viewProduct(12)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 5 -->
      <div class="belt-card">
        <img :src="belle" alt="Belle Belt">

        <div class="belt-info">
          <h3>Belle Belt</h3>
          <p>&#8358;6,000</p>

          <button @click="viewProduct(13)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 6 -->
      <div class="belt-card">
        <img :src="contrast" alt="Contrast Belt">

        <div class="belt-info">
          <h3>Contrast Belt</h3>
          <p>&#8358;9,500</p>

          <button @click="viewProduct(14)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 7 -->
      <div class="belt-card">
        <img :src="blush" alt="Blush Belt">

        <div class="belt-info">
          <h3>Blush Belt</h3>
          <p>&#8358;7,000</p>

          <button @click="viewProduct(15)">
            View Details
          </button>
        </div>
      </div>

      <!-- Belt 8 -->
      <div class="belt-card">
        <img :src="classic" alt="Classic Belt">

        <div class="belt-info">
          <h3>Classic Belt</h3>
          <p>&#8358;7,800</p>

          <button @click="viewProduct(16)">
            View Details
          </button>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      sterling: require('../assets/sterlingbelts.avif'),
      heritage: require('../assets/heritagebelt.avif'),
      aura: require('../assets/aurabelt.avif'),
      rugged: require('../assets/ruggedbelt.avif'),
      belle: require('../assets/bellebelt.jpg'),
      contrast: require('../assets/contrastbelt.jpg'),
      blush: require('../assets/Blushbelt.jpg'),
      classic: require('../assets/classicbelt.jpg')
    }
  },

  methods: {
    viewProduct(id) {
      this.$router.push('/product/' + id)
    }
  }
}
</script>

<style scoped>
.belt-products {
  padding: 80px 8%;
  background-color: #ffffff;
}

.section-heading {
  text-align: center;
  margin-bottom: 45px;
}

.section-heading h2 {
  font-size: 36px;
  color: #292929;
  margin-bottom: 10px;
}

.section-heading p {
  color: #4a4541;
}

.product-details{
  position: absolute;
  bottom: 20px;
  right: 15px;
  width: 180px;
  background:white;
  border-radius: 8px;
  color: #333;
  padding: 15px;
  z-index: 2;
  box-shadow: 0 4px 12px rgba (0, 0, 0, 0.2);

  box-sizing: border-box;
}


product-details button:first-of-type {
  background-color: #c66a4a;
  color: white;
}

.product-details button:last-of-type {
  background-color: #333;
  color: white;
  margin-left: 5px;
}

.product-details h5 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}

.product-details p {
  margin-bottom: 8px;
  font-size: 14px;
}
.product-details button {
  border: none;
  padding: 8px 12px;
  margin-top: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  transition: 0.2s ease;
}
.product-details button:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.belts-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.belt-card {
  background-color: #f5f0e8;
  overflow: hidden;
  transition: 0.3s;
}

.belt-card:hover {
  transform: translateY(-5px);
}

.belt-card img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.belt-info {
  padding: 20px;
}

.belt-info h3 {
  color: #292929;
  margin-bottom: 10px;
}

.belt-info p {
  color: #c96f4a;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.belt-info button {
  background-color: #c96f4a;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  transition: 0.3s;
}

.belt-info button:hover {
  background-color: #292929;
}

@media (max-width: 768px) {

  .belts-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .belt-card img {
    height: 220px;
  }

  .belt-info {
    padding: 15px;
  }

}

@media (max-width: 480px) {

  .belts-container {
    grid-template-columns: 1fr;
  }

  .belt-card img {
    height: 260px;
  }

}
</style>